import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=af7b90b0&scoped=true&"
import script from "./ChangePassword.vue?vue&type=script&lang=js&"
export * from "./ChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7b90b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af7b90b0')) {
      api.createRecord('af7b90b0', component.options)
    } else {
      api.reload('af7b90b0', component.options)
    }
    module.hot.accept("./ChangePassword.vue?vue&type=template&id=af7b90b0&scoped=true&", function () {
      api.rerender('af7b90b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/components/Profile/ChangePassword.vue"
export default component.exports